import { APP_COUNTRY, SANDSIV_ENABLED } from 'config';
import { UAParser } from 'ua-parser-js';
import { AppChannel, Channel } from 'utils/config.config';
import {
  CookieConsent,
  getOneTrustCookieConsent,
} from '../../functions/oneTrust';

export type TriggerType = 'cta' | 'auto';

export function triggerSurvey(
  apiUrl: string,
  surveyId: number,
  channel: Channel,
  accountId: string,
  triggerType: TriggerType,
  ipAddress?: string,
) {
  if (!canTriggerSurvey()) {
    return false;
  }

  try {
    window.VocSignal_SendEvent('SetParameters', {
      apiUrl,
      language: APP_COUNTRY || 'es',
      surveyId,
      metadata: getMetadata(
        surveyId,
        channel,
        accountId,
        triggerType,
        ipAddress,
      ),
    });

    window.VocSignal_ListenEvent('SetParametersCallback', () => {
      window.VocSignal_SendEvent('PopupSurvey');
    });
    return true;
  } catch (error) {
    console.error('Error triggering survey:', error);
    return false;
  }
}

export function loadSurveyScript(src: string) {
  const script = document.createElement('script');
  script.src = src;
  script.defer = true;
  document.body.appendChild(script);
}

function getMetadata(
  surveyId: number,
  channel: Channel,
  accountId: string,
  triggerType: TriggerType,
  ipAddress?: string,
) {
  const uaParser = new UAParser();

  const device = uaParser.getDevice();
  const os = uaParser.getOS();
  const isApp = channel !== AppChannel.PortaleWebFullResponsiveWwwSisalIt;

  return {
    PROPERTY: isApp ? 'app' : 'web',
    DEVICE_VENDOR: device.vendor,
    SCREEN_RESOLUTION: `${window.screen.width}x${window.screen.height}`,
    OPERATING_SYSTEM: os.name,
    BROWSER_LANGUAGE: navigator.language,
    ACCOUNT_ID: accountId,
    LANGUAGE: APP_COUNTRY || 'es',
    DEVICE_MODEL: device.model,
    FORM_ID: surveyId.toString(),
    LOGIN_STATUS: 'logged_in',
    TRIGGER_TYPE: triggerType,
    ...(ipAddress != null && { IP_ADDRESS: ipAddress }),
    // OS_VERSION: os.version, // This datum is unreliable
    // COUNTRY, // this would require a dedicated API call to a back-end service, avoid it isn't absolutely necessary
    // REGION, // this would require a dedicated API call to a back-end service, avoid it isn't absolutely necessary
    // CITY, // this would require a dedicated API call to a back-end service, avoid it isn't absolutely necessary
  } as const;
}

function canTriggerSurvey() {
  return (
    SANDSIV_ENABLED &&
    getOneTrustCookieConsent(CookieConsent.ProfilationTargeting)
  );
}
